// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zcJc","clinicsSelect":"styles_clinicsSelect__3s9CJ"};